import { createFeatureSelector } from "@ngrx/store";
import {
    ProtocolsState,
} from "./model";

export const PROTOCOL_FEATURE_KEY = "vadmin.health.protocol.templates";

export const getProtocolsState = createFeatureSelector<ProtocolsState>(PROTOCOL_FEATURE_KEY);
